import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  FunctionField,
  ShowButton,
  EditButton,
  ReferenceField,
  ImageField,
  NumberField,
  BooleanField,
} from "react-admin";

import {
  DateField,
  CreateOnlyTopToolbar,
} from "../../shared/components/index.js";

const listGasBrandMerchant = () => {
  const t = useTranslate();

  return (
    <List actions={<CreateOnlyTopToolbar />}>
      <Datagrid bulkActionButtons={false}>
        <ReferenceField source="logo_file_id" reference="File">
          <ImageField
            source="url"
            sx={{
              "& img": { maxWidth: 30, maxHeight: 30, objectFit: "contain" },
            }}
          />
        </ReferenceField>
        <ReferenceField source="merchant_id" reference="Merchant" link="show">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="gas_brand_id" reference="GasBrand" link="show">
          <TextField source="name" />
        </ReferenceField>
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.GasBrandMerchant.source.status.${record.status}`)
          }
        />
        <NumberField source="priority" />
        <BooleanField source="partner_gas_brand" />
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <ShowButton className="button-show" />
        <EditButton className="button-edit" />
      </Datagrid>
    </List>
  );
};

export default listGasBrandMerchant;
